import {
  ChangeDetectionStrategy,
  Component,
  DOCUMENT,
  ElementRef,
  inject,
  input,
  OnInit,
} from '@angular/core';

import { Subject } from 'rxjs';
import { GroupActionsHeaderComponent } from './components/group-actions-header/group-actions-header.component';
import { RequestFormDealDetailsComponent } from '../../../request-form/components/request-form-deal-details/request-form-deal-details.component';
import { RequestFormRatingsComponent } from '../../../request-form/components/request-form-ratings/request-form-ratings.component';

import {
  ActualDeliveryAddressGroupActionsViewComponent,
  ChangeStatusGroupActionsViewComponent,
  MainGroupActionsViewComponent,
  RequestInstallerGroupActionsViewComponent,
  SelectedRequestsGroupActionsViewComponent,
  GroupFilesUploadGroupActionsViewComponent,
  ChangeReleaseDateGroupActionsViewComponent,
} from './components';
import { GroupActionsViews } from '@features/requests/request-list/types';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'x-request-group-actions',
  imports: [
    MainGroupActionsViewComponent,
    SelectedRequestsGroupActionsViewComponent,
    GroupActionsHeaderComponent,
    ChangeStatusGroupActionsViewComponent,
    ActualDeliveryAddressGroupActionsViewComponent,
    RequestInstallerGroupActionsViewComponent,
    GroupFilesUploadGroupActionsViewComponent,
    ChangeReleaseDateGroupActionsViewComponent,
    RequestFormDealDetailsComponent,
    RequestFormRatingsComponent,
    TranslatePipe,
  ],
  templateUrl: './request-group-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestGroupActionsComponent implements OnInit {
  $viewObserver = input.required<Subject<never>>({
    alias: 'viewObserver',
  });

  readonly elementRef = inject(ElementRef);
  readonly document = inject(DOCUMENT);

  public readonly GroupActionsViewsTypes = GroupActionsViews;

  public previousView: GroupActionsViews = GroupActionsViews.Main;

  public viewMode: GroupActionsViews = GroupActionsViews.Main;

  changeViewMode(viewMode: GroupActionsViews): void {
    if (this.previousView !== GroupActionsViews.Main) {
      this.previousView = GroupActionsViews.Main;
    } else {
      this.previousView = this.viewMode;
    }
    this.viewMode = viewMode;
  }

  ngOnInit(): void {
    this.setDynamicStylesForSheet();
  }

  setDynamicStylesForSheet(): void {
    const sheet = this.elementRef.nativeElement.closest('.t-sheet');

    // Taiga v5: боковой отступ шторки задаётся переменной — по ней же полоска-ручка
    // (.t-bar) растягивается отрицательным margin. Прямой padding: 0 делал шторку
    // шире экрана, и на iOS её можно было возить в стороны.
    if (sheet) {
      sheet.style.setProperty('--tui-padding-inline', '0');
    }

    const content = this.document.querySelector('tui-sheet-dialog .t-content');

    if (content) {
      (content as HTMLElement).style.backgroundColor = '#ECECEC';
    }
  }
}
